module.exports = __webpack_public_path__ + "static/media/navbar_top.e6b64d52.png";